export const STALE_JWT_THRESHOLD_SECONDS = 5 * 60;
export const secondsUntilJwtExpiry = (jwt)=>{
    if (jwt == null) {
        return null;
    }
    const parts = jwt.split('.');
    if (parts.length !== 3) {
        return null;
    }
    try {
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        if (typeof payload.exp !== 'number') {
            return null;
        }
        return payload.exp - Math.floor(Date.now() / 1000);
    } catch (unused) {
        return null;
    }
};
